import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { number, arrayOf, bool, func, shape, string, oneOfType } from 'prop-types';
import Flex from '../../../atoms/Flex';
import ProductCarousel from '../../ProductCarousel';
import ProductCard from '../../ProductCard';
import HighlightTitle from '../highlight-title';
import { ProductCardContent } from '../showcase.styles';

const Carousel = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerView,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    offerTimerProps
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerView", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "offerTimerProps"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighlightTitle, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle
  }), /*#__PURE__*/React.createElement(Flex, null, highlight && /*#__PURE__*/React.createElement(ProductCardContent, {
    slidesPerView: slidesPerView
  }, /*#__PURE__*/React.createElement(ProductCard, _extends({}, highlight, {
    displayMode: "gallery",
    showInCashInfo: true,
    titleAs: "h3",
    fullHeight: true,
    imageAltPrefix: "",
    imgLazyLoading: true,
    imageWidth: props.imageWidth,
    imageHeight: props.imageHeight,
    showRating: false,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    key: `product-hightlight${highlight.variationId || highlight.id}`,
    offerTimerProps: offerTimerProps,
    enableHover: true
  }))), /*#__PURE__*/React.createElement(ProductCarousel, _extends({
    products: data,
    slidesPerView: highlight ? slidesPerView - 1 : slidesPerView,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    offerTimerProps: offerTimerProps
  }, props))));
};

Carousel.defaultProps = {
  slidesPerView: 4
};
process.env.NODE_ENV !== "production" ? Carousel.propTypes = {
  displayMode: string,
  data: arrayOf(shape),
  highlight: shape({}),
  title: string,
  titleAs: string,
  titleSize: oneOfType([string, number]),
  imageAltPrefix: string,
  productTitleAs: string,
  showFullListBtn: bool,
  showMoreBtn: bool,
  onClickLoadMore: func,
  showInCashInfo: bool,
  showPartialNextSlide: bool,
  auto: bool,
  slidesPerView: number,
  interval: number,
  transitionDuration: number,
  gutter: number,
  imgLazyLoading: bool,
  imageWidth: number,
  imageHeight: number,
  showControls: bool,
  showArrowControls: bool,
  showRating: bool,
  showDiscountOnlyCashInfo: bool,
  showDiscount: bool,
  showSponsoredSubTitle: bool,
  offerTimerProps: shape({})
} : void 0;
export default Carousel;